import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="text-sm text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Introduction</h2>
              <p>
                Asset Wave ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
                explains how we collect, use, disclose, and safeguard your information when you visit our website 
                and use our financial advisory services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Information We Collect</h2>
              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">Personal Information</h3>
              <p>We may collect the following personal information:</p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Name and contact details (phone number, email address)</li>
                <li>Date of birth and age</li>
                <li>Financial information (income, existing investments, insurance policies)</li>
                <li>Family details (for insurance planning purposes)</li>
                <li>KYC documents (PAN, Aadhaar, bank details) as required by regulations</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mt-4 mb-2">Automatically Collected Information</h3>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Browser type and IP address</li>
                <li>Pages visited and time spent on our website</li>
                <li>Referring website and clickstream data</li>
                <li>Device information and operating system</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">How We Use Your Information</h2>
              <p>We use the collected information for:</p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Providing personalized financial advisory services</li>
                <li>Processing insurance and investment applications</li>
                <li>Communicating with you about your policies and investments</li>
                <li>Sending service updates, newsletters, and promotional offers (with your consent)</li>
                <li>Complying with legal and regulatory requirements</li>
                <li>Improving our website and services</li>
                <li>Preventing fraud and ensuring security</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Information Sharing</h2>
              <p>We may share your information with:</p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li><strong>Insurance Companies & AMCs:</strong> To process your applications and service your policies/investments</li>
                <li><strong>Regulatory Authorities:</strong> As required by law (IRDAI, SEBI, AMFI, etc.)</li>
                <li><strong>Service Providers:</strong> Third-party vendors who assist in our operations (with strict confidentiality agreements)</li>
                <li><strong>Legal Requirements:</strong> When required by law, court order, or government regulations</li>
              </ul>
              <p className="mt-4">
                <strong>We do NOT sell your personal information to third parties.</strong>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Data Security</h2>
              <p>
                We implement appropriate technical and organizational measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction. This includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Secure socket layer (SSL) encryption for data transmission</li>
                <li>Restricted access to personal information on a need-to-know basis</li>
                <li>Regular security audits and updates</li>
                <li>Secure storage of physical documents</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2 my-4">
                <li>Access and receive a copy of your personal information</li>
                <li>Correct or update inaccurate information</li>
                <li>Request deletion of your information (subject to legal retention requirements)</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent for data processing (where applicable)</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Cookies</h2>
              <p>
                Our website uses cookies to enhance user experience and analyze site traffic. You can control cookie 
                preferences through your browser settings. Note that disabling cookies may affect website functionality.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Data Retention</h2>
              <p>
                We retain your personal information for as long as necessary to provide our services and comply with 
                legal obligations. Insurance and investment records are typically retained for 5-10 years or as 
                required by regulatory authorities.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. The updated version will be indicated by the 
                "Last updated" date. We encourage you to review this policy periodically.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy or wish to exercise your rights, please contact us:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4">
                <p><strong>Asset Wave</strong></p>
                <p>K Satish</p>
                <p>Phone: <a href="tel:+919248852187" className="text-blue-600">+91 92488 52187</a></p>
                <p>Email: <a href="mailto:contact@assetswaveww.com" className="text-blue-600">contact@assetswaveww.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
